export default {
  velt: {
    openPanel: 'Abrir painel de comentários',
    closePanel: 'Fechar painel de comentários',
    panel: 'Painel de comentários',
    tabs: 'Separadores do painel de comentários',
    comments: 'Comentários',
    settings: 'Definições e permissões',
    dragOrTapComment: 'Arraste para adicionar um comentário ou toque para ver os comentários',
    assignComment: 'Atribuir comentário',
    markAsUnread: 'Marcar como não lido',
    markAsRead: 'Marcar como lido',
    unsubscribe: 'Cancelar subscrição',
    subscribe: 'Subscrever',
    deleteThread: 'Eliminar tópico',
    editComment: 'Editar comentário',
    emptyPlaceholder: 'Dê feedback, faça uma pergunta ou deixe uma nota para os membros da sua equipa',
    searchPlaceholder: 'Pesquisar comentários',
    commentPlaceholder: 'Comentar em {page}',
    replyPlaceholder: 'Responder....',
    filterPages: 'Páginas',
    filterAuthor: 'Autor',
    filterTagged: 'Etiquetados',
    statusOpen: 'Aberto',
    statusResolved: 'Resolvido',
    anonymous: 'Anónimo',
    settingsPanel: {
      title: 'Quem pode comentar?',
      everyoneLabel: 'Todos',
      restrictedLabel: 'Apenas colaboradores convidados',
      emailsLabel: 'E-mails',
      emailsPlaceholder: 'Adicione um e-mail e prima Enter',
    },
  },
}
